import { render, staticRenderFns } from "./App.vue?vue&type=template&id=468df020&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=468df020&lang=css&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=468df020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468df020",
  null
  
)

export default component.exports